import React from "react";
import { motion } from "framer-motion";
import {
  MapPin,
  Baby,
  HeartHandshake,
  MessageCircle,
  Users,
  CalendarHeart,
} from "lucide-react";

const FEATURES = [
  {
    icon: MapPin,
    title: "Mamans près de chez toi",
    text: "Un matching local — pour que la rencontre soit possible dès demain.",
  },
  {
    icon: Baby,
    title: "Selon l'âge de l'enfant",
    text: "Nouveau-né, bambin, 3 ans. Trouve des mamans qui vivent la même phase.",
  },
  {
    icon: HeartHandshake,
    title: "Selon ta situation",
    text: "Grossesse, post-partum, allaitement, sommeil, diversification.",
  },
  {
    icon: MessageCircle,
    title: "Chat privé et bienveillant",
    text: "Une messagerie douce, sans jugement, pensée pour vraiment se parler.",
  },
  {
    icon: Users,
    title: "Rencontres réelles",
    text: "L'app te pousse à sortir — cafés, parcs, balades. Hors de l'écran.",
  },
  {
    icon: CalendarHeart,
    title: "Événements entre mamans",
    text: "Ateliers, brunchs, cafés poussette organisés localement.",
  },
];

const EASE = [0.2, 0.7, 0.2, 1];

export default function WhyMamaMatch() {
  return (
    <section
      id="pourquoi"
      data-testid="why-section"
      className="relative py-20 md:py-32 bg-[#F7F5F2]"
    >
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="max-w-[720px] mb-14 md:mb-20">
          <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#D97757]">
            Pourquoi MamaMatch
          </p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mt-4 font-display text-[32px] sm:text-[42px] md:text-[52px] text-[#0A0A0A]"
          >
            Pensée pour toi, à chaque étape.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                data-testid={`feature-card-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{
                  duration: 0.7,
                  ease: EASE,
                  delay: (i % 3) * 0.06,
                }}
                className="mm-card p-7 md:p-9 h-full flex flex-col"
              >
                <div className="w-10 h-10 rounded-full bg-[#F7F5F2] flex items-center justify-center text-[#0A0A0A] mb-7">
                  <Icon className="w-5 h-5" strokeWidth={1.6} />
                </div>
                <h3 className="font-display text-[19px] md:text-[22px] leading-[1.2] text-[#0A0A0A]">
                  {f.title}
                </h3>
                <p className="mt-3 text-[14px] md:text-[15px] leading-[1.55] text-[#6B6660]">
                  {f.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
